module.exports = __webpack_public_path__ + "img/poddar.246c3cf2.png";